export default (({
  options,
  newFilters,
  newPerspective
}) => {
  return { ...options,
    newFilters,
    newPerspective
  };
});